// imports
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// local imports
import { BASEMAPS } from '../../constants/BasemapOptions';
import { useUrlParameters } from '../../hooks/useUrlParameters';
import { mapActions, RootState } from '../../store';

/**
 * BasemapInitializer
 *
 * Component that initializes the basemap from URL parameter on app load.
 * Only runs once on mount - BasemapOption.tsx handles all subsequent basemap changes.
 */
export const BasemapInitializer = () => {
  const dispatch = useDispatch();
  const { getParameter, setParameter } = useUrlParameters();
  const currentBasemap = useSelector((state: RootState) => state.map?.basemap);

  useEffect(() => {
    const basemapFromUrl = getParameter('basemap');

    if (basemapFromUrl) {
      // URL has basemap - use it if valid
      const foundBasemap = BASEMAPS.find(
        (basemap) => basemap.identifier === basemapFromUrl
      );

      if (
        foundBasemap &&
        foundBasemap.identifier !== currentBasemap?.identifier
      ) {
        dispatch(mapActions.setBasemap(foundBasemap));
      } else if (!foundBasemap) {
        // Invalid URL param - fix it
        setParameter('basemap', currentBasemap.identifier);
      }
    } else if (currentBasemap) {
      // No URL param - initialize it with current basemap
      setParameter('basemap', currentBasemap.identifier);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default BasemapInitializer;
